import React from "react";
import { createRoot } from 'react-dom/client'
import ReactFAQ from "./ReactFAQ";

function faq() {
    let b = document.querySelector('body'),
		reactWrapper = b.querySelectorAll('.js-react-faq .js-content');

		reactWrapper.forEach((item, idx) => {
			let dataUrl = item.dataset.url;
			$.when(
				$.getJSON(dataUrl, (data)=> {
					initReactFAQ(item, idx, data);
				}).fail(( jqxhr, textStatus, error ) => {
					let err = textStatus + ", " + error;
					console.log( "Request Failed: " + err );
				})
			);
		});


}

function initReactFAQ(reactContainer, idx, faqData) {
    let currentModule = reactContainer.closest('.js-react-faq');

    const root = createRoot(reactContainer)
    root.render(
        <ReactFAQ
            faqData={faqData}
			moduleIdx={idx}
        />
    )
    currentModule.classList.remove('js-loading')
}

window.addEventListener('DOMContentLoaded', function (e) {
    faq()
})